"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _ShoppingBag = _interopRequireDefault(require("wix-ui-icons-common/on-stage/ShoppingBag"));
var FullscreenCartIcon = /*#__PURE__*/function (_React$Component) {
  function FullscreenCartIcon() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(FullscreenCartIcon, _React$Component);
  var _proto = FullscreenCartIcon.prototype;
  _proto.render = function render() {
    var _this = this;
    var count = this.props.cartItemsCount > 0 ? /*#__PURE__*/_react["default"].createElement("span", null, this.props.cartItemsCount) : false;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "fullscreen-icon fullscreen-cart-icon has-custom-focus",
      onClick: function onClick() {
        return _this.props.showCart && _this.props.showCart();
      },
      title: "Cart",
      "aria-label": "Cart",
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement("button", {
      tabIndex: -1
    }, /*#__PURE__*/_react["default"].createElement(_ShoppingBag["default"], {
      size: "24"
    })), count);
  };
  return FullscreenCartIcon;
}(_react["default"].Component);
var _default = exports["default"] = FullscreenCartIcon;